var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 14.4C12.637 14.4 13.2475 14.1471 13.6975 13.6971C14.1476 13.247 14.4005 12.6365 14.4005 12C14.4005 11.3635 14.1476 10.753 13.6975 10.3029C13.2475 9.85286 12.637 9.6 12.0005 9.6C11.364 9.6 10.7535 9.85286 10.3034 10.3029C9.85334 10.753 9.60049 11.3635 9.60049 12C9.60049 12.6365 9.85334 13.247 10.3034 13.6971C10.7535 14.1471 11.364 14.4 12.0005 14.4Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0981 10.716L17.2205 8.596L18.4005 7.2L16.8005 5.6L15.4125 6.7864L13.2469 5.896L12.7485 4H11.1853L10.6797 5.9208L8.56369 6.8128L7.20049 5.6L5.60049 7.2L6.76289 8.6312L5.89889 10.7568L4.00049 11.2V12.8L5.92129 13.324L6.81329 15.44L5.60049 16.8L7.20049 18.4L8.63329 17.232L10.7181 18.0896L11.2005 20H12.8005L13.2837 18.0904L15.4045 17.212C15.7581 17.4648 16.8005 18.4 16.8005 18.4L18.4005 16.8L17.2133 15.4L18.0917 13.2784L20.0005 12.7824V11.2L18.0981 10.716Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.90bc6ac63fc470b9988f9add3756b608.svg";
export { ForwardRef as ReactComponent };